<template>
    <div>
        <kendo-datepicker :ref="'datepicker' + uid"
                          :value="dateValue"
                          @change="inputChanged"
                          :format="customFormat"
                          :id="'datepicker' + uid"
                          :name="'datepicker' + uid"
                          v-validate="required ? 'required' : ''"
                          style="width: 100%;"
                          :start="datepickerStart"
                          :depth="datepickerDepth"
                          :disabled="readonly"
                          :min="dateMinVal"
                          :max="dateMaxVal"
                          :data-vv-as="fieldName"></kendo-datepicker>
        <span class="text-danger col-12" v-if="errors.has('datepicker' + uid)">{{ errors.first('datepicker' + uid) }}</span>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            value: [Date, String],
            required: {
                type: Boolean,
                default: false
            },
            format: {
                type: String
            },
            showTime: {
                type: [Boolean, String],
                default: true
            },
            readonly: {
                type: Boolean,
                default: false
            },
            min: {
                type: [Date, String],
                required: false
            },
            max: {
                type: [Date, String],
                required: false
            },
            showOnlyYear: {
                type: Boolean,
                default: false
            },
            fieldName: String,
            convertToLocalTime: {
                type: Boolean,
                default: true
            },
            useUtcTime: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                uid: Math.floor(Math.random() * 0x10000).toString(16),
                dateValue: '',
                changedFromPicker: false,
                defaultDateMinVal: new Date(1900, 0, 1),
                defaultDateMaxVal: new Date(2159, 0, 1),
                customFormat: ''
            };
        },
        methods: {
            inputChanged(event) {
                this.changedFromPicker = true;
                if (event.sender.value()) {
                    if (this.useUtcTime) {
                        this.$emit('input', event.sender.value().toUTCString());
                    } else {
                        this.$emit('input', event.sender.value());
                    }
                } else {
                    this.$emit('input', event.sender.value());
                }
            },
            convertFromUtcToLocal() {
                if (this.value) {
                    let dateUtc = new Date(this.value);
                    if (dateUtc && dateUtc.getTimezoneOffset() > 0) {
                        this.dateValue = new Date(
                            Date.UTC(
                                dateUtc.getFullYear(),
                                dateUtc.getMonth(),
                                dateUtc.getDate(),
                                dateUtc.getHours(),
                                dateUtc.getMinutes(),
                                dateUtc.getSeconds()
                            )
                        );
                    } else {
                        this.dateValue = dateUtc;
                    }
                }
            }
        },
        computed: {
            datepickerStart() {
                return this.showOnlyYear ? 'decade' : 'month'; // mounth is default value
            },
            datepickerDepth() {
                return this.showOnlyYear ? 'decade' : '';
            },
            dateMinVal() {
                var d = this.min || this.defaultDateMinVal;
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
            dateMaxVal() {
                var d = this.max || this.defaultDateMaxVal;
                return new Date(d.getFullYear(), d.getMonth(), d.getDate());
            },
        },
        watch: {
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (this.changedFromPicker) {
                        this.changedFromPicker = false;
                        return;
                    }

                    if (this.convertToLocalTime) {
                        this.convertFromUtcToLocal();
                    } else {
                        if (this.value) {
                            this.dateValue = this.value;
                        }
                    }
                }
            }
        },
        mounted() {
            kendo.culture('bg-BG');

            if (!this.format) {
                if (this.showOnlyYear) {
                    this.customFormat = 'yyyy';
                } else {
                    if (!this.showTime) {
                        this.customFormat = 'dd.MM.yyyy';
                    } else {
                        this.customFormat = 'dd.MM.yyyy HH:mm';
                    }
                }
            } else {
                this.customFormat = this.format;
            }

            if (this.convertToLocalTime) {
                this.convertFromUtcToLocal();
            } else {
                if (this.value) {
                    this.dateValue = this.value;
                }
            }
        }
    };
</script>
